"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const react_bootstrap_1 = require("react-bootstrap");
class EmailPanel extends React.Component {
    render() {
        return React.createElement("div", { className: "email-panel text-center" }, React.createElement("h4", { className: "text-center" }, "Start Now FREE"), React.createElement("span", { className: "text-danger pointer text-center", onClick: () => this.callTo() }, "Call 818-404-5005"), " or", React.createElement("span", { className: "text-center" }, React.createElement("a", { onClick: () => this.mailTo(), href: "#contact" }, React.createElement(react_bootstrap_1.Image, { className: "email-icon", src: "../img/email.png" }), "info@LoyalReach.com")));
    }
    callTo() {
        document.location.href = "tel:+18184045005";
    }
    mailTo() {
        // document.location.href = "mailto:info@LoyalReach.com";
    }
}
exports.default = react_redux_1.connect(null, null)(EmailPanel);


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/emailPanel/emailPanel.tsx
// module id = 1096
// module chunks = 0 1